// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import {
  ImageryResolution,
  VideoResolution,
  ImageryFormat,
  UploadMethod,
  IntervalType,
  UploadFormat,
  CameraDirection,
  GroupCameraStatus
} from '../constants/setting'
import { api } from './index'

export interface IGeneralSetting {
  imageryResolution: ImageryResolution
  videoResolution: VideoResolution
  imageryFmt: ImageryFormat
  uploadMethod: UploadMethod
  intervalType: IntervalType
  captureInterval: number
  captureDistanceInterval: number
  powerSave: boolean
  aiImageQuality: boolean
  aiTrafficSign: boolean
  aiPoi: boolean
  aiScene: boolean
  aiPrivacy: boolean
  gpsUploadInterval: number
  imuUploadInterval: number
  workTimeStart: string
  workTimeEnd: string
  trafficQuota: number
  alertThreshold: number // %
  hardThreshold: number // %
  uploadFmt: UploadFormat
}

export interface IInternalSetting {
  imageCompressRatio: number
  rephotographFlag: boolean
  deleteImageFlag: boolean
  reCaptureConfigBlurredFlag: boolean
  reCaptureConfigCorruptFlag: boolean
  reCaptureConfigNormalFlag: boolean
  reCaptureConfigOverExposedFlag: boolean
  reCaptureConfigUnderExposedFlag: boolean
  reCaptureMaxCount: number
}

export type CombinedSettings = IGeneralSetting & Partial<IInternalSetting>
export interface ILastSetting {
  ImageryResolution: ImageryResolution
  VideoResolution: VideoResolution
  ImageryFmt: ImageryFormat
  UploadMethod: UploadMethod
  IntervalType: IntervalType
  CaptureInterval: number
  CaptureDistanceInterval: number
  PowerSave: boolean
  AiImageQuality: boolean
  AiTrafficSign: boolean
  AiPoi: boolean
  AiScene: boolean
  AiPrivacy: boolean
  GpsUploadInterval: number
  ImuUploadInterval: number
  WorkTimeStart: string
  WorkTimeEnd: string
  UploadFmt: UploadFormat
  Id: number
  TimeZoneOffset: number
  ImageCompressRatio: number
}

export interface IGroupCamera {
  direction: CameraDirection
  deviceID: string
  cityID: number
}

export interface ICameraGroupSettingsRes {
  groupID: string
  status: GroupCameraStatus
  masterDeviceID: string
  masterDirection: CameraDirection
  slaves: IGroupCamera[]
}

export interface ICameraGroupQuerySetting {
  // driverID: string
  slaves: Omit<IGroupCamera,'cityID'>[]
}

export function getGeneralSetting (cityID: number): Promise<IGeneralSetting> {
  return api.get(`/general-settings/${cityID}`)
}

export function updateGeneralSetting (cityID: number, value: Partial<IGeneralSetting>) {
  return api.patch(`/general-settings/${cityID}`, value)
}

export function getDeviceSetting (deviceID: string): Promise<CombinedSettings> {
  return api.get(`/device-settings/${deviceID}`)
}

export function updateDeviceSetting (deviceID: string, value: Partial<CombinedSettings>) {
  return api.patch(`/device-settings/${deviceID}`, value)
}

export function getLastReportSetting (deviceID: string): Promise<ILastSetting> {
  return api.get(`/device-last-settings/${deviceID}`)
}
export function getCameraGroupSettingByID(groupID: number): Promise<ICameraGroupSettingsRes>{
 return api.get(`/devices/group/${groupID}`)
}
export function updateCameraGroupSetting(groupID: number, value:ICameraGroupQuerySetting): Promise<ICameraGroupSettingsRes>{
  return api.post(`/devices/group/${groupID}`,value)
}
